import {
  LanguageNameSpaces,
  SubscriptionDuration,
  SubscriptionPlanType,
} from "@shared/types";
import {
  BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH,
  IS_WEB_VIEW,
} from "common/constants";
import { PROMO_CODE_QUERY_PARAM } from "features/settings/common/constants";
import { SubscriptionStep } from "@shared/features/settings/subscription/types";
import {
  SubscriptionInvoiceType,
  SubscriptionInvoiceTypeValueType,
} from "analytics/events";
import { SUBSCRIPTION_QUERY_PARAMS } from "@shared/features/settings/subscription/constants";
import { TranslationKeys } from "@shared/common/i18n/types.ts";

export const getPurchaseSubscriptionPath = ({
  isUpgrade,
  step,
  isAllPlans,
  plan,
  duration,
  promoCode,
}: {
  isUpgrade?: boolean;
  step?: SubscriptionStep;
  isAllPlans?: boolean;
  plan?: SubscriptionPlanType;
  duration?: SubscriptionDuration;
  promoCode?: string | null;
}) => {
  let basePath = BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH;
  const query = new URLSearchParams();
  if (isUpgrade) query.set(SUBSCRIPTION_QUERY_PARAMS.IS_UPGRADE, "1");
  if (step) query.set(SUBSCRIPTION_QUERY_PARAMS.STEP, step);
  if (isAllPlans) query.set(SUBSCRIPTION_QUERY_PARAMS.IS_ALL_PLANS, "1");
  if (plan) query.set(SUBSCRIPTION_QUERY_PARAMS.PLAN, plan.toString());
  if (duration)
    query.set(SUBSCRIPTION_QUERY_PARAMS.DURATION, duration.toString());
  if (promoCode) query.set(PROMO_CODE_QUERY_PARAM, promoCode);

  if (step || isAllPlans || plan || duration || promoCode || isUpgrade) {
    basePath += `?${query.toString()}`;
  }

  return basePath;
};

export const getAnalyticsInvoiceType = (
  isUpgrade?: boolean,
  isExtend?: boolean,
  isGroup?: boolean
): SubscriptionInvoiceTypeValueType => {
  let invoiceType: SubscriptionInvoiceTypeValueType =
    SubscriptionInvoiceType.NEW;
  if (isGroup) {
    invoiceType = SubscriptionInvoiceType.SIGNALS_GROUP_EXTENSION;
  } else if (isUpgrade) {
    invoiceType = SubscriptionInvoiceType.UPGRADE;
  } else if (isExtend) {
    invoiceType = SubscriptionInvoiceType.EXTENSION;
  }
  return invoiceType;
};

export const getClientQuotaText = (
  t: (key: TranslationKeys<LanguageNameSpaces.BILLING>, params?: any) => string,
  isAlternative?: boolean,
  canPurchase?: boolean
) => {
  if (canPurchase === false) {
    const prefix = t("quota_modal.client_quota_prefix");
    return t("quota_modal.client_quota_text_no_purchase", { prefix });
  }
  const prefix = isAlternative
    ? t("quota_modal.client_quota_alternative_prefix")
    : t("quota_modal.client_quota_prefix");
  const suffix = IS_WEB_VIEW
    ? t("quota_modal.client_quota_webview_suffix")
    : t("quota_modal.client_quota_suffix");
  return t("quota_modal.client_quota_text", { prefix, suffix });
};
